import { Injectable, inject, provideAppInitializer, signal } from '@angular/core';

export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'wasel.admin.theme';
const DARK_CLASS = 'wasel-dark';

/** Stored choice, else prefers-color-scheme, else light. */
function readInitialMode(): ThemeMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'light' || raw === 'dark') return raw;
  } catch {
    // storage unavailable
  }
  try {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

/** Owns the light/dark mode and the `wasel-dark` class on <html>. */
@Injectable({ providedIn: 'root' })
export class ThemeModeService {
  readonly mode = signal<ThemeMode>(readInitialMode());

  /** Applies the resolved mode to the document. Run at bootstrap so /login honours it too. */
  init(): void {
    this.apply();
  }

  toggle(): void {
    this.mode.set(this.mode() === 'dark' ? 'light' : 'dark');
    try {
      localStorage.setItem(STORAGE_KEY, this.mode());
    } catch {
      // storage unavailable
    }
    this.apply();
  }

  private apply(): void {
    document.documentElement.classList.toggle(DARK_CLASS, this.mode() === 'dark');
  }
}

export function provideThemeInit() {
  return provideAppInitializer(() => inject(ThemeModeService).init());
}
